import { render } from "./PurchaseHouse.vue?vue&type=template&id=0be841ee&scoped=true"
import script from "./PurchaseHouse.vue?vue&type=script&lang=js"
export * from "./PurchaseHouse.vue?vue&type=script&lang=js"

import "./PurchaseHouse.vue?vue&type=style&index=0&id=0be841ee&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be841ee"]])

export default __exports__